<template>
  <div>
    <x-table
      listApi="biz.warehouse.goods.stock.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无库存信息"
      :fieldList="fieldList"
      :defaultParams="defaultParams"
      :actionWidth="100"
    >
      <template slot="row-info" slot-scope="scope">
        <div style="color: #919191">
          <span> 货位编号: </span>
          <span style="color: #333333; font-size: 16px">
            {{ scope.row.shelfLocation }}
          </span>
        </div>
        <div style="color: #919191">
          <span> 入库时间: </span>
          <span style="color: #333333">
            {{ new Date(scope.row.inventoryTime).format("YYYY-MM-dd hh:mm:ss") || "" }}
          </span>
        </div>
        <div style="color: #919191" v-if="scope.row.batchCode">
          <span> 生产批次: </span>
          <span style="color: #333333">
            {{ scope.row.batchCode || "" }}
          </span>
        </div>
        <div style="color: #919191" v-if="scope.row.packTime > 0">
          <span> 生产日期: </span>
          <span style="color: #333333">
            {{ new Date(scope.row.packTime).format("YYYY-MM-dd") || "" }}
          </span>
        </div>
        <div style="color: #919191" v-if="scope.row.validTime > 0">
          <span> 有效日期: </span>
          <span style="color: #333333">
            {{ new Date(scope.row.validTime).format("YYYY-MM-dd") || "" }}
          </span>
        </div>
        <div style="color: #919191">
          <span> 成本单价: </span>
          <span style="color: #333333">
            {{ scope.row.costPrice || "-" }}
          </span>
          <span>元/份</span>
        </div>
      </template>
    </x-table>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        optCancel: 0,
        storeGuid: this.pageParams.storeGuid,
        goodsGuid: this.pageQuery.guid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "库存信息",
          minWidth: "220",
          slot: "info",
        },
        {
          label: "库存数量",
          width: "120",
          render: (row) => row.stockCount,
        },
      ],
    };
  },
};
</script>
